export const LANGUAGES = ['sr', 'en', 'ru', 'zh-CN'] as const;
export type LanguageCode = typeof LANGUAGES[number];

export const isSupportedLanguage = (value?: string): value is LanguageCode => {
  return LANGUAGES.includes(value as LanguageCode);
};
